module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAElBMVEUAAAD///////////////////8+Uq06AAAABXRSTlMAOx7DxI8ndU8AAAA2SURBVBjTYyALMIdCgQGQwyoYKCoI4gRgcEAMGAcBUGTwcxRAipmwyzDh1MNE2GiEFxzICgEAQBgncjmHQiEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_website_active.png
// module id = eyWW
// module chunks = 9